module.exports = __webpack_public_path__ + "assets/img/ftr-func-2.b51a61b6.png";